//url for production
import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../assets/constant";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
export var url = "";
if (process.env.NODE_ENV === "development") {
  url = "";
} else {
  url = window.location.host.split("/")[1];
  if (url) {
    url = `/${window.location.host.split("/")[1]}`;
  } else url = process.env.PUBLIC_URL; /// ADD YOUR CPANEL SUB-URL
}

//Function to validate and return errors for a form
export const checkForm = (formData) => {
  let errorState = {};
  Object.keys(formData).forEach((item) => {
    if (formData[item] === null || formData[item] === "") {
      errorState[item] = "This field is required";
    }
  });
  return errorState;
};

//Function that returns the first or first two letters from a name
export const findUpper = (string) => {
  if(!string) return
  let extractedString = [];

  for (var i = 0; i < string.length; i++) {
    if (string.charAt(i) === string.charAt(i).toUpperCase() && string.charAt(i) !== " ") {
      extractedString.push(string.charAt(i));
    }
  }
  if (extractedString.length > 1) {
    return extractedString[0] + extractedString[1];
  } else {
    return extractedString[0];
  }
};

//Function that calculates the from current date
export const setDeadline = (days) => {
  let todayDate = new Date();
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

// Function to set deadline for projects
export const setDeadlineDays = (deadline) => {
  var currentDate = new Date();
  var difference = deadline.getTime() - currentDate.getTime();
  var days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

//Date formatter function
export const dateFormatterAlt = (date, reverse) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  reverse ? (date = m + "-" + d + "-" + y) : (date = y + "-" + d + "-" + m);
  return date;
};

//Date formatter function
export const dateFormatter = (date, reverse) => {
  var dateformat = date.split("-");
  //var date = dateformat[1]+"-"+dateformat[2]+"-"+dateformat[0];
  reverse
    ? (date = dateformat[2] + "-" + dateformat[0] + "-" + dateformat[1])
    : (date = dateformat[1] + "-" + dateformat[2] + "-" + dateformat[0]);
  return date;
};

//Month Names
export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

//todays Date
export const todaysDate = new Date();

// Function to structure date ex : Jun 4, 2011;
export const getDateStructured = (date) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  let final = monthNames[m] + " " + d + ", " + y;
  return final;
};

/** India Standard Time (Asia/Kolkata) for display in tables and exports */
export const IST_TIMEZONE = "Asia/Kolkata";

/**
 * Format an ISO date string or Date as IST for UI (tables, tooltips).
 * @param {string|Date|number|null|undefined} value
 * @param {Intl.DateTimeFormatOptions} [options] optional Intl overrides
 */
export const formatDateTimeIST = (value, options) => {
  if (value === null || value === undefined || value === "") return "—";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return new Intl.DateTimeFormat("en-IN", {
    timeZone: IST_TIMEZONE,
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    ...options,
  }).format(d);
};

/**
 * Human-readable message from API JSON (FastAPI `detail`, custom `message`, etc.).
 * Use for failed responses and axios `error.response.data`.
 */
export const formatApiErrorMessage = (data) => {
  if (data == null) return "";
  if (typeof data === "string") return data;
  const detail = data.detail;
  if (detail != null) {
    if (Array.isArray(detail)) {
      return detail
        .map((d) =>
          typeof d === "string" ? d : d.msg || d.message || (d.type && d.loc ? `${d.loc?.join?.(".")}: ${d.msg || d.type}` : "")
        )
        .filter(Boolean)
        .join("; ");
    }
    return String(detail);
  }
  if (typeof data.message === "string" && data.message) return data.message;
  if (data.error != null) return typeof data.error === "string" ? data.error : JSON.stringify(data.error);
  return "";
};

/** Toast-friendly line: main message + optional nested `data` from API */
export const formatApiFailureForToast = (payload) => {
  const main = formatApiErrorMessage(payload) || "Something went wrong.";
  const inner = payload?.data;
  if (inner == null) return main;
  if (typeof inner === "string" && inner.trim()) return `${main} — ${inner}`;
  if (typeof inner === "object" && !Array.isArray(inner) && Object.keys(inner).length) {
    return `${main} — ${JSON.stringify(inner)}`;
  }
  return main;
};

/**
 * Normalize API response into { kind, message, expired } for toasts.
 * Supports payload shape: { status: true|false|"expired", message, data }.
 */
export const getToastMetaFromApiResponse = (resOrPayload) => {
  const res = resOrPayload && typeof resOrPayload === "object" && "status" in resOrPayload && "data" in resOrPayload
    ? resOrPayload
    : null;
  const httpStatus = res?.status;
  const payload = res?.data ?? resOrPayload;

  const apiStatus = payload?.status;
  const expired = apiStatus === "expired";

  // message preference: payload.message/detail/error; include http status when not 2xx
  const baseMessage = formatApiFailureForToast(payload || {}) || "Something went wrong.";
  const message = httpStatus && (httpStatus < 200 || httpStatus >= 300) ? `${baseMessage} (HTTP ${httpStatus})` : baseMessage;

  if (expired) return { kind: "error", message, expired: true };
  if (apiStatus === true) return { kind: "success", message: payload?.message || "Success", expired: false };
  if (apiStatus === false) {
    const kind = httpStatus && httpStatus >= 500 ? "error" : "warning";
    return { kind, message, expired: false };
  }
  if (httpStatus && httpStatus >= 400) return { kind: "error", message, expired: false };
  return { kind: "info", message, expired: false };
};

/**
 * Extra context when POST /api/create-user returns the generic MySQL failure envelope.
 * (Server: except mysql.connector.Error → "Failed to create user", data: {})
 */
export const formatCreateUserDbFailureHint = (payload, httpStatus) => {
  const main = formatApiFailureForToast(payload || {});
  const inner = payload?.data;
  const emptyInner =
    inner == null || (typeof inner === "object" && !Array.isArray(inner) && !Object.keys(inner || {}).length);
  const looksGeneric = /failed to create user/i.test(main);
  if (looksGeneric && emptyInner) {
    return `${main} (HTTP ${httpStatus ?? "?"}). Your API hides the real error: inside except mysql.connector.Error, add logging (e.g. logger.exception(err)) and check MySQL: INSERT into login (username, password, role, status) must match table columns, ENUM values, and constraints.`;
  }
  return httpStatus != null ? `${main} (HTTP ${httpStatus})` : main;
};

// Function to structure date ex: YYYY-MM-DD
export const setDateForPicker = (rdate) => {
  let d = rdate.getDate();
  d < 10 && (d = "0" + d);
  let m = rdate.getMonth() + 1;
  m < 10 && (m = "0" + m);
  let y = rdate.getFullYear();
  rdate = y + "-" + m + "-" + d;

  return rdate;
};

//current Time
export const currentTime = () => {
  var hours = todaysDate.getHours();
  var minutes = todaysDate.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

//Percentage calculation
export const calcPercentage = (str1, str2) => {
  let result = Number(str2) / Number(str1);
  result = result * 100;
  return Math.floor(result);
};

//shortens a long string
export const truncate = (str, n) => {
  return str.length > n ? str.substr(0, n - 1) + " " + truncate(str.substr(n - 1, str.length), n) : str;
};

// returns upload url
export const getUploadParams = () => {
  return { url: "https://httpbin.org/post" };
};

// Converts KB to MB
export const bytesToMegaBytes = (bytes) => {
  let result = bytes / (1024 * 1024);
  return result.toFixed(2);
};

export const bulkActionOptions = [
  { value: "suspend", label: "Suspend User" },
  { value: "delete", label: "Delete User" },
];



//!MY FUNCTIONS
//! MY FUNCTIONS
export const getToken = () => {
  return localStorage.getItem("accessToken");
};
const getLanguage = () => {
  return localStorage.getItem("language") || "en";
};

export const createHeaders = () => {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
      Language: getLanguage(),
    },
  };
};

export const createFormHeaders = () => {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getToken()}`,
      Language: getLanguage(),
    },
  };
};
export const createHeadersAdmin = () => {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
  };
};
export const createFormHeadersAdmin = () => {
  return {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${getToken()}`,
    },
  };
};
export const encrypt = (data) => {
  const cipherText = CryptoJS.AES.encrypt(JSON?.stringify(data), SECRET_KEY)?.toString();
  return cipherText;
};

export const decrypt = (cipherText) => {
  try {
    const bytes = CryptoJS?.AES?.decrypt(cipherText, SECRET_KEY);
    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedStr) {
      console.error("Decryption failed: empty string");
      return null;
    }

    return JSON.parse(decryptedStr);
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

/** Logged in admin user object from localStorage (set in Login.js). */
export const getLoggedInAdmin = () => {
  try {
    const raw = localStorage.getItem("userDetail");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

/** Permission keys list (e.g. ["qa.view", "users.view"] or ["*"] for superadmin). */
export const getLoggedInAdminPermissions = () => {
  const u = getLoggedInAdmin();
  const perms = u?.permissions;
  if (!perms) return [];
  if (Array.isArray(perms)) return perms.filter(Boolean).map((p) => String(p).trim());
  return [];
};

export const hasAdminPermission = (permissionKey) => {
  const key = String(permissionKey || "").trim();
  if (!key) return true;
  const perms = getLoggedInAdminPermissions();
  if (perms.includes("*")) return true;
  return perms.includes(key);
};



export const exportToExcel11 = (data,selectedKeys) => {
  const formattedData = data.map((item) => {
    let questionsArray = [];

    try {
      // Step 1: extract string and parse JSON
      const raw = item.questions?.[0]; // string
      questionsArray = raw ? JSON.parse(raw) : [];
    } catch (err) {
      console.error("Question parse error:", err);
    }

    return {
      ID: item.id,
      Keyword: item.keyword,
      Category: item.category,

      // ✅ Join questions with newline
      Questions: questionsArray.join(",\n"),

      Short_Answer: item.answer_short,
      Detailed_Answer: item.answer_detail,
      Helpline: item.contact_info?.helpline,
      Department: item.contact_info?.department,
      Website: item.contact_info?.website,
      Status: item.status,
      Created_At: item.created_at,
    };
  });

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(formattedData);

  // Optional: wrap text in Excel
  const range = XLSX.utils.decode_range(worksheet["!ref"]);
  for (let row = range.s.r; row <= range.e.r; row++) {
    const cellAddress = XLSX.utils.encode_cell({ r: row, c: 3 }); // Questions column
    if (worksheet[cellAddress]) {
      worksheet[cellAddress].s = { alignment: { wrapText: true } };
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(file, "exported_data.xlsx");
};
export const exportToExcel = (data, selectedKeys,fileName="Exported File") => {
  const formattedData = data.map((item) => {
    let questionsArray = [];

    try {
      const raw = item.questions;

      if (Array.isArray(raw)) {
        // Case 1: Already an array
        // Sometimes it's ["child"], sometimes it's a JSON string inside
        if (raw.length === 1 && typeof raw[0] === "string") {
          const first = raw[0].trim();
          if (first.startsWith("[") && first.endsWith("]")) {
            // JSON stringified array
            questionsArray = JSON.parse(first);
          } else {
            // Plain string
            questionsArray = raw;
          }
        } else {
          // Proper array of strings
          questionsArray = raw;
        }
      } else if (typeof raw === "string") {
        // Case 2: Just a string
        const str = raw.trim();
        if (str.startsWith("[") && str.endsWith("]")) {
          questionsArray = JSON.parse(str);
        } else {
          questionsArray = [str];
        }
      }
    } catch (err) {
      console.error("Question parse error:", err);
    }

    return {
      ID: item.id,
      Keyword: item.keyword,
      Category: item.category,
      Questions: questionsArray.join(",\n"),
      Short_Answer: item.answer_short,
      Detailed_Answer: item.answer_detail,
      Helpline: item.contact_info?.helpline || item.contact_info?.helpline_numbers,
      Department: item.contact_info?.department,
      Website: item.contact_info?.website,
      Status: item.status,
      Created_At: item.created_at,
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(formattedData);

  const range = XLSX.utils.decode_range(worksheet["!ref"]);
  for (let row = range.s.r; row <= range.e.r; row++) {
    const cellAddress = XLSX.utils.encode_cell({ r: row, c: 3 }); // Questions column
    if (worksheet[cellAddress]) {
      worksheet[cellAddress].s = { alignment: { wrapText: true } };
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(file, `${fileName}.xlsx`);
};


 

// Helper to get nested values
const getValue = (obj, path) => {
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
};

export const exportToExcel1 = (data, selectedKeys = [],fileName="exported_file") => {
  const formattedData = data.map((item) => {
    let row = {};

    selectedKeys.forEach((key) => {
      // ✅ Special handling for questions
      if (key === "questions") {
        let questionsArray = [];

        try {
          const raw = item.questions?.[0];
          questionsArray = raw ? JSON.parse(raw) : [];
        } catch (err) {
          console.error("Question parse error:", err);
        }

        row["Questions"] = questionsArray.join(",\n");
      }

      // ✅ Handle nested keys
      else if (key.includes(".")) {
        const label = key.split(".").pop(); // last key as column name
        row[label.charAt(0).toUpperCase() + label.slice(1)] =
          getValue(item, key);
      }

      // ✅ Normal keys
      else {
        const label =
          key.charAt(0).toUpperCase() + key.slice(1).replaceAll("_", " ");
        const raw = item[key];
        if (key === "created_at" || key === "updated_at") {
          row[label] = formatDateTimeIST(raw);
        } else {
          row[label] = raw;
        }
      }
    });

    return row;
  });

  // Create worksheet
  const worksheet = XLSX.utils.json_to_sheet(formattedData);

  // ✅ Wrap text for Questions column (if selected)
  if (selectedKeys.includes("questions")) {
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    const questionColIndex = Object.keys(formattedData[0]).indexOf("Questions");

    if (questionColIndex !== -1) {
      for (let row = range.s.r; row <= range.e.r; row++) {
        const cellAddress = XLSX.utils.encode_cell({
          r: row,
          c: questionColIndex,
        });

        if (worksheet[cellAddress]) {
          worksheet[cellAddress].s = { alignment: { wrapText: true } };
        }
      }
    }
  }

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(file, `${fileName}.xlsx`);
};
